import { render, staticRenderFns } from "./BaseAppTopNav.vue?vue&type=template&id=31b301f7&scoped=true"
import script from "./BaseAppTopNav.vue?vue&type=script&lang=js"
export * from "./BaseAppTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b301f7",
  null
  
)

export default component.exports